// extracted by mini-css-extract-plugin
export default {"schedule":"Schedule_schedule__gN2Co","delete":"Schedule_delete__WNRPo","break":"Schedule_break__WpxzX","wrapper":"Schedule_wrapper__BZgVv"};